import request from "@/utils/request";
import { Local } from "@/utils/storage";

//按电话导入学员
export function inviteByPhones(param:any){
    let path = "/user/mechanismInvite/phones"
   
    return request.post(path,param)
}

//批量导入学员
export function inviteByExcel(param:any){
    let path = "/user/mechanismInvite/batch"
   
    return request.post(path,param,{
        processData: false,
        headers: { "Content-Type": "multipart/form-data" },
      })
}


//获取活动详情
export function activityInfo(id:string | number){
    let path = "/user/mechanismActivity/findById"
   
    return request.get(path,{id})
}



//获取账号绑定的机构列表
export function getAdminBindMec(){
    let path = "/user/adminMec/queryMec"
    let param = {
        admin_id: Local.get('managerInfo').id
    } 

    return request.get(path,param)
}

//小店商品
export function queryShopGoods(data:any){
    let path = "/user/product/queryShopGoods"
    let param = {
        mechanism_id: Local.get('current_mechanism').id,
        ...data
    } 

    return request.get(path,param)
}


export function addCoupon(data:any){
    let path = "/user/commoditycoupon/insert"
    let param = {
        mechanism_id: Local.get('current_mechanism').id,
        ...data
    } 

    return request.post(path,param)
}



export function updateCoupon(data:any){
    let path = "/user/commoditycoupon/update"
    let param = {
        ...data
    } 

    return request.post(path,param)
}


export function sendCoupon(data:any){
    let path = "/user/userCoupon/mecSendCoupon"
    let param = {
        ...data
    } 

    return request.post(path,param)
}